<template>
    <form-select
        placeholder="日"
        selectName="day"
        :optionList="dayOptions"
        v-model="day"
        :value="dayValue"
        :blur-event="onBlur"
        data-jest="select-day"
    />
</template>

<script>
import FormSelect from "../atoms/FormSelect.vue";
import moment from "moment";
export default {
    name: "InputProfileItemDay",
    components: {FormSelect},
    props: {
        /**
         * storeのyear
         */
        yearValue: {
            type: String,
            required: true
        },
        /**
         * storeのmonth
         */
        monthValue: {
            type: String,
            required: true
        },
        /**
         * storeのday
         */
        dayValue: {
            type: String,
            required: true
        },
        /**
         * 入力値が空か
         * blur時のバリデーション判定用
         */
        isEmpty: {
            type: Boolean,
            required: true
        },
    },
    emits: ['input'],
    computed: {
        day: {
            get() {
                return this.dayValue
            },
            set(value) {
                return this.emit(value);
            }
        },
        isEmptyDay: {
            get() {
                return this.isEmpty
            },
            set() {
                return this.emit(this.day);
            }
        },
        /**
         * 選択した年と月によって日のoptionを生成する
         */
        dayOptions() {
            let list = [];
            let startDay = 1
            let lastDay = 31

            if(this.yearValue !== '' && this.monthValue !== '') {
                const now = moment();
                const isCurrentYearAndMonth =
                    this.yearValue === now.year().toString() && this.monthValue === (now.month() + 1).toString()

                lastDay = isCurrentYearAndMonth ? now.date() : new Date(this.yearValue, this.monthValue,0).getDate()
            }
            for(let i = startDay; i <= lastDay; i++) {
                list.push({id: `${i}`, label: `${i}`})
            }
            return list;
        },
    },
    methods: {
        /**
         * blur時に日の入力値の有無をチェックする
         */
        onBlur() {
            this.isEmptyDay = !this.dayValue;
        },
        /**
         * 親にemitする共通メソッド
         */
        emit(dayValue) {
            this.$emit("input", dayValue);
        },
    },
}
</script>
